<template>
  <div class="document-source">
    <UIDocumentIcon :source/>
    <span>{{ sourceLabel }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { DocumentClass, DocumentSource } from '@types'
import { DOCUMENT_FIELD, DOCUMENT_SOURCE_LABEL } from '@/entities/documents/utils/const'
import { UIDocumentIcon } from '@ui/core'

type Props = {
  item: DocumentClass
}

const { item } = defineProps<Props>()

const source = computed(() =>  item.field<DocumentSource>(DOCUMENT_FIELD.SOURCE).value)
const sourceLabel = computed(() => DOCUMENT_SOURCE_LABEL[source.value])
</script>

<style scoped>
.document-source {
  @apply flex items-center gap-2;

  svg {
    @apply shrink-0;
    @apply w-6 h-6;
  }

  span {
    @apply overflow-hidden text-ellipsis whitespace-nowrap;
  }
}
</style>
